import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { authCodeFlowConfig } from 'src/app/auth.config';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private readonly oauthService: OAuthService) { }

  initializeOAuth(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.oauthService.configure(authCodeFlowConfig);

      this.oauthService.loadDiscoveryDocumentAndTryLogin()
        .then(() => {
          if (this.oauthService.hasValidAccessToken()) {
            this.oauthService.setupAutomaticSilentRefresh();
          } else {
            this.oauthService.initCodeFlow(); // trigger login
          }
          resolve();
        })
        .catch(err => {
          console.error('OAuth init error', err);
          reject(err);
        });
    });
  }
}
